export function NavLink(props) {
    return (
        <a className="NavLink" href={props.target}>{props.name}</a>
    )
}